module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"language":"Language","transporter":"Transporter"},"no":{"language":"Språk","transporter":"Transportør"}}')
  delete Component.options._Ctor
}
